import { trackGameStart } from './analytics';

/**
 * Catat play ke backend (fire-and-forget, tidak menghambat navigasi)
 * dan kirim event ke Google Analytics
 */
export function trackPlay(slug: string, gameName?: string, category?: string, isPremium?: boolean): void {
  // Track to backend
  fetch(`/api/plays/${slug}`, { method: 'POST' }).catch(() => {
    // Silently ignore — tracking tidak boleh ganggu UX
  });
  
  // Track to Google Analytics
  trackGameStart(slug, gameName || slug, category, isPremium);
}
